import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from './token.service';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class BaseHttpService {
  abstract baseUrl;
  token: string | null = null;
  options: any;

  constructor(
    protected http: HttpClient,
    protected tokenService: TokenService
  ) {
    this.token = tokenService.getToken();
    this.options = {
      headers: new HttpHeaders({ Authorization: 'Bearer ' + this.token }),
    };
  }
}
